import type { IAttentionStatusesItem } from '../types'

/**
 * The level's rows, worst level first.
 *
 * The catalog orders statuses by its own `sortOrder`, which reads as an arbitrary sequence once
 * the rows state their priority: a `Top` row can then sit under a `Medium` one. Sorting by level
 * puts the rows in the order the tile is read in, and the catalog's order is kept inside a level,
 * so two rows of the same priority still follow it.
 */
export const sortAttentionItemsBySeverity = (
  items: IAttentionStatusesItem[]
): IAttentionStatusesItem[] => [...items].sort((left, right) => right.severity - left.severity)
